import { Fragment, ReactNode } from 'react';
import { useImageStoreActions } from '../../stores/imageStore';
import { BoundingBoxType, Coordinate } from '../../types';
import './imageHighlighter.styles.css';

type RowHighlighterPropsType = {
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    top: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    height: number;
    /** Value used to indicate a primary highlight */
    primary?: boolean;
};

function RowHighlighter({ top, height, primary }: RowHighlighterPropsType) {
    const styles = {
        top: `${top * 100}%`,
        height: `${height * 100}%`,
    };

    return <div className={`image-highlighter__row ${primary ? 'primary' : ''}`} style={styles}></div>;
}

type CellHighlighterPropsType = {
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    top: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    height: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    left: number;
    /** Value is in decimal notation of percentage So 25% means 0.25*/
    width: number;
    /** Value used to indicate a primary highlight */
    primary?: boolean;
};

function CellHighlighter({ top, height, left, width, primary }: CellHighlighterPropsType) {
    const styles = {
        top: `${top * 100}%`,
        height: `${height * 100}%`,
        left: `${left * 100}%`,
        width: `${width * 100}%`,
    };

    return <div className={`image-highlighter__cell ${primary ? 'primary' : ''}`} style={styles}></div>;
}

type HighlighterWrapperProps = {
    boundingBox: Partial<BoundingBoxType>;
    children: ReactNode;
};

export function ImageHighlighterWrapper({ children, boundingBox }: HighlighterWrapperProps) {
    const actions = useImageStoreActions();
    return (
        <div
            className="image-highlighter__wrapper"
            onPointerEnter={() => actions.setCoordinates(boundingBox)}
            onPointerLeave={actions.clearCoordinates}
        >
            {children}
        </div>
    );
}

type ImageHighlighterPropsType = {
    children: ReactNode;
    coordinates: Coordinate[];
    highlightCells?: boolean;
    highlightRows?: boolean;
};

function ImageHighlighter({
    coordinates,
    children,
    highlightCells = true,
    highlightRows = true,
}: ImageHighlighterPropsType) {
    return (
        <div className="image-highlighter">
            {children}
            {coordinates.map((coords, index) => {
                return (
                    <Fragment key={index}>
                        {highlightRows && (
                            <RowHighlighter top={coords.top} height={coords.height} primary={coords.primary} />
                        )}
                        {highlightCells && (
                            <CellHighlighter
                                top={coords.top}
                                height={coords.height}
                                left={coords.left}
                                width={coords.width}
                                primary={coords.primary}
                            />
                        )}
                    </Fragment>
                );
            })}
        </div>
    );
}

export default ImageHighlighter;
